<template>
  <div class="c-app">
    <TheSidebar
      v-bind:minimize="minimize"
      @minimize-sidebar="(minimize = !minimize), toggleSidebar()"
    />
    <div class="c-wrapper" style="margin-top: -1px">
      <TheHeader @minimize-sidebar="(minimize = !minimize), toggleSidebar()" />
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <keep-alive :exclude="['Portfolio']">
              <router-view :key="$route.fullPath + currentTime"></router-view>
            </keep-alive>
          </CContainer>
        </main>
      </div>
      <TheFooter />
    </div>
  </div>
</template>

<script>
import TheSidebar from "./TheSidebar";
import TheHeader from "./header/TheHeader";
import TheFooter from "./TheFooter";
import { EventBus } from "../components/Events";

export default {
  name: "TheContainer",
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
  },
  data() {
    return {
      currentTime: Date.parse(new Date()).toString(),
      minimize: true,
      user: this.$auth.user.UserDetails,
    };
  },
  watch: {
    $route: function () {
      this.currentTime = Date.parse(new Date()).toString();
    },
  },
  beforeCreate: function () {
    let savedCookie = this.$cookies.get("savedUser");
    console.log(
      "Logged in as:",
      this.$auth.user,
      "Saved User Cookie:",
      savedCookie
    );
    if (savedCookie && this.$auth.user.email == savedCookie.email) {
      this.$auth.user.UserDetails = savedCookie;
    }

    if (this.$matomo) {
      this.$matomo.setCustomVariable(
        1,
        "Company",
        this.$auth.user.UserDetails.Contact_Company_RecID
      );
      this.$matomo.setCustomVariable(
        2,
        "UserID",
        this.$auth.user.UserDetails.Contact_RecID
      );
      this.$matomo.trackPageView("Initial Page Load");
    }

    // if(this.$matomo) {
    //   this.$matomo.setCustomVariable(1, "Company", this.$auth.user.UserDetails.Contact_Company_RecID);
    //   this.$matomo.setCustomVariable(2, "UserID", this.$auth.user.UserDetails.Contact_RecID);
    // }
  },
  methods: {
    toggleSidebar() {
      // resizing DMA chart
      EventBus.$emit("resize-chart");
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/customGrid.scss";
</style>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.c-main {
  padding-top: 0px;
  /* background-color: rgba(35, 35, 35, 0.9); */
  background-color: white;
}
.c-main > .container-fluid {
  padding-left: 0px;
  padding-right: 0px;
}

</style>
